import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { User } from "lucide-react";
import { getBlogAuthors } from "../lib/supabase";

export default function AuthorIndex() {
  const [authors, setAuthors] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchAuthors() {
      try {
        setLoading(true);
        const data = await getBlogAuthors();
        setAuthors(data);
      } catch (err) {
        console.error("Error fetching authors:", err);
        setError("Failed to load authors");
      } finally {
        setLoading(false);
      }
    }

    fetchAuthors();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#F98B3D]"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-md">
        <p className="text-red-700">{error}</p>
      </div>
    );
  }

  return (
    <div>
      <h1 className="blog-title">Authors</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {authors.map((author) => (
          <Link
            key={author.id}
            to={`/blog/author/${author.slug}`}
            className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow duration-200"
          >
            <div className="flex items-center mb-4">
              {author.image_url ? (
                <img
                  src={author.image_url}
                  alt={author.name}
                  className="h-12 w-12 rounded-full mr-4"
                />
              ) : (
                <User className="h-12 w-12 text-gray-400 mr-4" />
              )}
              <div>
                <h2 className="text-xl font-semibold text-gray-900">
                  {author.name}
                </h2>
                {author.bio && (
                  <p className="text-gray-600 text-sm mt-1 line-clamp-2">
                    {author.bio}
                  </p>
                )}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
